import accueil from "./accueil";
import oauth2 from "./oauth2";
import association from "./association";
import requete from "./requete";
import NotFoundView from "@/views/NotFoundView";


export default [
    ...oauth2,
    ...accueil,
    ...association,
    ...requete,
    {
        path: "*",
        component: NotFoundView,
    },
];
